import { NORMALIZE_DATA_CONFIG } from './config';

export default function (labelsIds) {
    if (labelsIds) {
        const ids = labelsIds.split(NORMALIZE_DATA_CONFIG.labelsIdsSeparator);
        return ids.map(id => parseInt(id, 10));
    }
    return [];
}
